module.exports = {
  "projectName": "anotherworld",
  "env": "develop",
  "siteUrl": "https://unshift.co.jp/labs/particleTransition"
}